import { useEffect } from 'react';

import { Route, Routes } from 'react-router-dom';
import { SectionType } from './sectionConfig';
import { logSectionEnvStatus } from './utils/envValidator';

// 各地域のコンポーネントをインポート
import { JianList } from 'pages/JianList';
import { JianDetail } from 'pages/JianDetail';

import { HiroshimaJianDetail } from './hiroshima/pages/IncidentDetail';
import { HiroshimaJianList } from './hiroshima/pages/JianList';

import { IncidentDetailPage } from './ube/pages/IncidentDetail';
import { IncidentListPage } from './ube/pages/IncidentList';

/**
 * ユーザーのdepartmentIdに基づいて適切な地域のコンポーネントを表示するルーター
 */
export const SectionRoutes = ({
  sectionType,
}: {
  sectionType: SectionType;
}) => {
  // 開発環境で環境変数の設定状況をログ出力
  useEffect(() => {
    logSectionEnvStatus();
  }, []);

  // 地域によって使用するコンポーネントを設定する
  const getRoutes = () => {
    const baseRoutes = [
      { path: '/jian-list', element: <JianList /> },
      { path: '/jian-detail/:incidentId/:patientId', element: <JianDetail /> },
    ];
    const ubeRoutes = [
      { path: '/jian-list', element: <IncidentListPage /> },
      {
        path: '/jian-detail/:incidentId/:patientId',
        element: <IncidentDetailPage />,
      },
    ];
    const hiroshimaRoutes = [
      { path: '/jian-list', element: <HiroshimaJianList /> },
      {
        path: '/jian-detail/:incidentId/:patientId',
        element: <HiroshimaJianDetail />,
      },
    ];

    switch (sectionType) {
      case 'okinawa':
        return baseRoutes;
      case 'niigata':
        return baseRoutes;
      case 'hiroshima':
        return hiroshimaRoutes;
      case 'ube':
        return ubeRoutes;
      default:
        return baseRoutes;
    }
  };

  return (
    <Routes>
      {getRoutes().map(({ path, element }) => (
        <Route key={path} path={path} element={element} />
      ))}
    </Routes>
  );
};
